import { useMutation } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import { SimulabFeedback } from "../../models"
import { Urls } from "../urls"

export function useSendSimulabFeedback() {
    return useMutation({ mutationFn: (feedback: SimulabFeedback) => axiosClient.post(Urls.sendFeedback(), feedback) })
}
